var DateTime = luxon.DateTime;

var currentTime = window.currentTime !== "" ? DateTime.fromFormat(window.currentTime, "yyyy-MM-dd hh:mm a").setZone('Asia/Kolkata') : DateTime.now().setZone('Asia/Kolkata');

const allEqual = arr => arr.every(val => val === arr[0]);

function makeTitle(slug) {
  var words = slug.split("-");
  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }
  return words.join(" ");
}

function makeSlug(title) {
    return String(title)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

function populateCities(e) {
    if (e) {
        if (window.TimeSlotConfig.cities.length) {
          window.TimeSlotConfig.cities.forEach(el => {
            let newOption = new Option(el, makeSlug(el));
            e.add(newOption, undefined);
          });
        }
    }
}

function checkNullUndefined(e) {
  return e == null || e == undefined || e == "undefined";
}

function createCookie(e, t, n) {
  if (n) {
    var a = new Date();
    a.setTime(a.getTime() + 24 * n * 60 * 60 * 1000);
    var c = "; expires=" + a.toGMTString();
  } else c = "";
  document.cookie = e + "=" + t + c + "; path=/";
}

function createShortCookie(e, t, n) {
  if (n) {
    var a = new Date();
    a.setTime(a.getTime() + n * 60 * 1000);
    var c = "; expires=" + a.toGMTString();
  } else c = "";
  document.cookie = e + "=" + t + c + "; path=/";
}

function readCookie(e) {
  for (
    var t = e + "=", n = document.cookie.split(";"), a = 0;
    a < n.length;
    a++
  ) {
    for (var c = n[a]; " " == c.charAt(0); ) c = c.substring(1, c.length);
    if (0 == c.indexOf(t)) return c.substring(t.length, c.length);
  }
  return null;
}

function eraseCookie(e) {
  createCookie(e, "", -1);
}

function availabeSlots() {
  let availableSlotsCookie = readCookie('slots');
  if (checkNullUndefined(availableSlotsCookie) || localStorage.getItem("slots") === null) {
    fetch(`${window.timeSlotStrings.appUrl}/api/get-slots`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((responseJson) => {
      eraseCookie("slots");
      createShortCookie("slots", 'Available', 15);
      localStorage.removeItem("slots");
      localStorage.setItem("slots", JSON.stringify(responseJson));
    });
  }
  return JSON.parse(localStorage.getItem("slots"));
}

// async function availableSlots() {
//   let availableSlotsCookie = readCookie('slots');
  
//   if (checkNullUndefined(availableSlotsCookie) || localStorage.getItem("slots") === null) {
//     try {
//       const response = await fetch(`${window.timeSlotStrings.appUrl}/api/get-slots`);
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }
      
//       const responseJson = await response.json();
      
//       eraseCookie("slots");
//       createShortCookie("slots", 'Available', 15);
//       localStorage.removeItem("slots");
//       localStorage.setItem("slots", JSON.stringify(responseJson));
      
//     } catch (error) {
//       console.error("Failed to fetch slots:", error);
//     }
//   }
  
//   return JSON.parse(localStorage.getItem("slots"));
// }

function prepareIntervals(variantData) {
  var dates_array = {
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    deliveryStart: DateTime.fromFormat(variantData.thresholdDeliveryStart, "hh:mm a").toFormat("HH:mm:ss"),
    deliveryEnd: DateTime.fromFormat(variantData.thresholdDeliveryEnd, "hh:mm a").toFormat("HH:mm:ss"),
    kitchenStart: DateTime.fromFormat(variantData.thresholdKitchenStart, "hh:mm a").toFormat("HH:mm:ss"),
    kitchenEnd: DateTime.fromFormat(variantData.thresholdKitchenEnd, "hh:mm a").toFormat("HH:mm:ss")
  };

  var todayDateString = currentTime.toFormat("dd LLL yyyy");

  var stringFormat = "dd LLL yyyy hh:mm a";
  
  const kitchenThresholdStart = DateTime.fromFormat(
    `${todayDateString} ${variantData.thresholdKitchenStart}`,
    stringFormat
  );

  const kitchenThresholdEnd = DateTime.fromFormat(
    `${todayDateString} ${variantData.thresholdKitchenEnd}`,
    stringFormat
  );

  if (luxon.Interval.fromDateTimes(kitchenThresholdStart, kitchenThresholdEnd).contains(currentTime)) {
    var firstSlotCalcTime = variantData.minHoursRequired > 2
      ? currentTime.startOf("hour")
      : currentTime.plus({hours: 1}).startOf("hour")
  } else if (currentTime < kitchenThresholdStart) {
    var firstSlotCalcTime = kitchenThresholdStart;
  } else {
    var firstSlotCalcTime = kitchenThresholdStart.plus({days: 1});
  }

  var calculateFirstSlot = firstSlotCalcTime.plus({hours: variantData.minHoursRequired});

  var isLimitedAvailableStart =
    variantData.availableFrom !== null && variantData.availableFrom != ""
      ? DateTime.fromFormat(
          `${DateTime.fromFormat(variantData.availableFrom, "yyyy-MM-dd").toFormat(
            "dd LLL yyyy"
          )} ${variantData.thresholdDeliveryStart}`,
          stringFormat
        )
      : calculateFirstSlot;

  if (calculateFirstSlot < isLimitedAvailableStart) {
    dates_array.startDate = isLimitedAvailableStart.toFormat("EEE, dd LLL yyyy");
    dates_array.startTime = variantData.thresholdDeliveryStart;
  } else {
    var setDateString = calculateFirstSlot.toFormat("dd LLL yyyy");
    const orderDeliveryThresholdStart = DateTime.fromFormat(
      `${setDateString} ${variantData.thresholdDeliveryStart}`,
      stringFormat
    );
    const orderDeliveryThresholdEnd = DateTime.fromFormat(
      `${setDateString} ${variantData.thresholdDeliveryEnd}`,
      stringFormat
    );

    if (luxon.Interval.fromDateTimes(orderDeliveryThresholdStart, orderDeliveryThresholdEnd).contains(calculateFirstSlot)) {
      var getFirstAvailableSlot = calculateFirstSlot;
    } else if (calculateFirstSlot < orderDeliveryThresholdStart) {
      var getFirstAvailableSlot = DateTime.fromFormat(
        `${setDateString} ${variantData.thresholdDeliveryStart}`,
        stringFormat
      );
    } else {
      var getFirstAvailableSlot = DateTime.fromFormat(
        `${setDateString} ${variantData.thresholdDeliveryStart}`,
        stringFormat
      ).plus({days: 1});
    }

    dates_array.startDate = getFirstAvailableSlot.toFormat("EEE, dd LLL yyyy");
    dates_array.startTime = getFirstAvailableSlot.toFormat("hh:mm a");
  }

  if (variantData.minStartTime !== null) {
    var calculatedFirstSlot = currentTime.plus({hours: variantData.minHoursRequired});
    var possibleFirstSlot = DateTime.fromFormat(`${calculatedFirstSlot.toFormat("dd LLL yyyy")} ${variantData.minStartTime}`, stringFormat);

    dates_array.startDate = possibleFirstSlot < calculatedFirstSlot 
      ? calculatedFirstSlot.plus({days: 1}).toFormat("EEE, dd LLL yyyy")
      : possibleFirstSlot.toFormat("EEE, dd LLL yyyy");
    dates_array.startTime = variantData.thresholdDeliveryStart;
    dates_array.startFirstTime = variantData.minStartTime;
  }

  if (variantData.minStartTimeOff !== null) {
    if (!luxon.Interval.fromDateTimes(orderCreationThresholdStart, orderCreationThresholdEnd).contains(currentTime)) {
      var getMinDeliveryDT = currentTime.plus({hours: variantData.minHoursRequiredOffThreshold}),
        getMinDeliveryDate = getMinDeliveryDT.toFormat("dd LLL yyyy"),
        calcMinDeliveryDT = DateTime.fromFormat(`${getMinDeliveryDate} ${variantData.minStartTimeOff}`, stringFormat);

      if (calcMinDeliveryDT < getMinDeliveryDT) {
        calcMinDeliveryDT = calcMinDeliveryDT.plus({days: 1});
      }

      dates_array.startDate = calcMinDeliveryDT.toFormat("EEE, dd LLL yyyy");
      dates_array.startTime = variantData.thresholdDeliveryStart;
      dates_array.startFirstTime = variantData.minStartTimeOff;
    }
  }

  if (variantData.availableTill !== null && variantData.availableTill != "") {
    var isLimitedAvailableEnd = DateTime.fromFormat(variantData.availableTill, "yyyy-MM-dd");
    var availabilityStart = DateTime.fromFormat(dates_array.startDate, "EEE, dd LLL yyyy");
    dates_array.endDate = isLimitedAvailableEnd > availabilityStart
      ? isLimitedAvailableEnd.toFormat("EEE, dd LLL yyyy")
      : "";
  } else {
    dates_array.endDate = DateTime.fromFormat(dates_array.startDate, "EEE, dd LLL yyyy").plus({days: window.TimeSlotConfig.maxAllowedDays}).toFormat("EEE, dd LLL yyyy");
  }

  dates_array.endTime = variantData.thresholdDeliveryEnd;
  
  return prepareTimeSlots(dates_array);
}

function prepareTimeSlots(inputDates) {
  if (inputDates.endDate === "") {
    return [];
  }

  const availableSlotsCookie = availabeSlots();

  var startDate = DateTime.fromFormat(
    `${inputDates.startDate} ${inputDates.startTime}`,
    "EEE, dd LLL yyyy hh:mm a"
  );

  var initialDate = startDate;
  
  var thresholdDate = DateTime.fromFormat(
    `${inputDates.endDate} ${inputDates.endTime}`,
    "EEE, dd LLL yyyy hh:mm a"
  );

  var limitDateTimeSlot = readCookie("deliverySlot");

  if (!checkNullUndefined(limitDateTimeSlot)) {
    var definedDate = limitDateTimeSlot.includes(", ") ? limitDateTimeSlot : limitDateTimeSlot.replace(",", ", ");
  } else {
    var definedDate = false;
  }

  var returnData = [];

  while (startDate.hasSame(thresholdDate, "day") || startDate <= thresholdDate) {
    var value = {
      interval: "01:00:00",
      startTime: inputDates.deliveryStart,
      endTime: inputDates.deliveryEnd
    };

    if (startDate.hasSame(initialDate, "day")) {
      value.startTime = startDate.toFormat("HH:mm:ss");
      if (typeof inputDates.startFirstTime !== "undefined") {
        value.startTime = DateTime.fromFormat(inputDates.startFirstTime, "hh:mm A").toFormat("HH:mm:ss");
      }
    }

    var inputDataFormat = "HH:mm:ss";
    var outputFormat = "hh:mm a";

    var intervals = [];

    var tmp = DateTime.fromFormat(value.interval, inputDataFormat);
    var dif = tmp - DateTime.now().startOf("day");

    var startIntervalTime = DateTime.fromFormat(value.startTime, inputDataFormat);
    var endIntervalTime = DateTime.fromFormat(value.startTime, inputDataFormat).plus({milliseconds: dif});
    var finishTime = DateTime.fromFormat(value.endTime, inputDataFormat);

    while (startIntervalTime < finishTime) {
      var format =
        startIntervalTime.toFormat(outputFormat) +
        " - " +
        endIntervalTime.toFormat(outputFormat);
      
      let currentSlot = `${startDate.toFormat("EEE, dd LLL yyyy")} ${format}`;
      
      if (availableSlotsCookie.includes(currentSlot)) {
        if (definedDate !== false && currentSlot === definedDate)  {
          intervals.push(format);  
        }
        if (definedDate === false) {
          intervals.push(format);
        }
      }
      startIntervalTime = startIntervalTime.plus({milliseconds: dif});
      endIntervalTime = endIntervalTime.plus({milliseconds: dif});
    }

    const pushData = {
      date: startDate.toFormat("yyyy-MM-dd"),
      timeSlots: intervals
    };

    var pushDatatoArray = true;

    let selected_dates = window.TimeSlotConfig.disabledDays;

    var dates_data = [];
    if (selected_dates.length) {
      selected_dates.forEach((el) => {
        if (DateTime.fromFormat(el, "yyyy-MM-dd").isValid) {
          dates_data.push(DateTime.fromFormat(el, "yyyy-MM-dd"));
        }
      });
    }

    dates_data.forEach((el) => {
      if (startDate.hasSame(el, "day")) {
        pushDatatoArray = false;
      }
    });

    if (pushDatatoArray && pushData.timeSlots.length) {
      returnData.push(pushData);
    }

    startDate = startDate.plus({days: 1});
  }

  return returnData;
}

function hideInput(block) {
  block.querySelectorAll(".date-time-picker-inputs").forEach(el => {
    el.style.display = "none";
  });
}

function showInput(block) {
  if (block.querySelector(".timeslot-bundles") !== null) {
    block.querySelector(".timeslot-bundles").style.display = "flex";
  }
  block.querySelectorAll(".date-time-picker-inputs").forEach(el => {
    el.style.display = "flex";
  });
}

function showMessage(block, message, type = "error") {
  block.querySelectorAll(".outstation-message").forEach(el => {
    if (type === "success") {
      el.classList.add("success");
      el.classList.remove("error");
      block.querySelector('button[type="submit"]').disabled = "";
    } else {
      el.classList.add("error");
      el.classList.remove("success");
      if (block.querySelector(".timeslot-bundles") !== null) {
        block.querySelector(".timeslot-bundles").style.display = "none";
      }
      block.querySelector('button[type="submit"]').disabled = "disabled";
    }
    el.style.display = "block";
    el.innerHTML = message;
  });
}

function hideMessage(block) {
  if (block.querySelector(".timeslot-bundles") !== null) {
    block.querySelector(".timeslot-bundles").style.display = "flex";
  }
  block.querySelectorAll(".outstation-message").forEach(el => {
    el.style.display = "none";
  });
}

function enableButton(block) {
  if (block.querySelector(".timeslot-bundles") !== null) {
    let bundlesBlock = block.querySelector(".timeslot-bundles");
    if (bundlesBlock.dataset.maxAllowed === bundlesBlock.dataset.currentQuantity) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function initSingleTimeSlot(block, type) {
  var parentSection = type == "product" ? block.closest(".m-main-product--info") : block.closest(".m-product-info--wrapper");

  try {
    var timingData = JSON.parse(block.dataset.timings);
  } catch (e) {
    console.log(e);
    console.log("Error processing the JSON data.");
    hideInput(parentSection);
    showMessage(
      parentSection,
      window.timeSlotStrings.invalidJson
    );
    return;
  }

  var currentCity = readCookie("delivery-city");

  var productForm = type == "product"
  ? parentSection.querySelector('form[class^="product-form-template--"]')
  : parentSection.querySelector('form[class^="product-form-product-quickview"]');

  updateText(currentCity);

  var currentCityTimings = timingData[currentCity];

  if (checkNullUndefined(currentCityTimings)) {
    hideInput(parentSection);
    showMessage(
      parentSection,
      window.timeSlotStrings.cityDataNotDefined
    );
    return;
  }

  var currentVariant = block.dataset.variantId;
  var checkAvailability = currentCityTimings.find(
    el => el.variantId == currentVariant
  );
  
  if (!checkNullUndefined(checkAvailability) && checkAvailability.isAvailable) {
    if (checkAvailability.method === 3) {
      hideInput(parentSection);
      if (checkAvailability.isLimited) {
        var currentMoment = currentTime;
        var availableFrom = DateTime.fromFormat(checkAvailability.availableFrom, "yyyy-MM-dd");
        var availableTill = DateTime.fromFormat(checkAvailability.availableTill, "yyyy-MM-dd");
        
        if (availableTill < currentMoment) {
          showMessage(
            parentSection,
            window.timeSlotStrings.productNotAvailable
          );
        }

        if (availableFrom > currentMoment) {
          var minAvailableFrom = currentTime.plus({days: checkAvailability.minDaysRequired});
          var setDeliveryStart = minAvailableFrom > availableFrom  ? minAvailableFrom : availableFrom;
        } else {
          var setDeliveryStart = currentTime.plus({days: checkAvailability.minDaysRequired});
        }
        var setDeliveryEnd = setDeliveryStart.plus({days: 2});
        showMessage(
          parentSection,
          `The selected product will be delivered between ${setDeliveryStart.toFormat(
            "EEE, DD"
          )} and ${setDeliveryEnd.toFormat("EEE, DD")}.`,
          "success"
        );
      } else {
        let setDeliveryStart = currentTime.plus({days: checkAvailability.minDaysRequired});
        let setDeliveryEnd = setDeliveryStart.plus({days: 2});
        showMessage(
          parentSection,
          `The selected product will be delivered between ${setDeliveryStart.toFormat(
            "EEE, DD"
          )} and ${setDeliveryEnd.toFormat("EEE, DD")}.`,
          "success"
        );
      }
      return;
    }

    var prepareTimes = {
      minHoursRequired: checkAvailability.minHoursRequired,
      availableFrom: null,
      availableTill: null,
      minStartTime: null,
      minStartTimeOff: null,
      minHoursRequiredOffThreshold: null,
      thresholdKitchenStart: window.TimeSlotConfig.thresholdKitchenStart,
      thresholdKitchenEnd: window.TimeSlotConfig.thresholdKitchenEnd,
      thresholdDeliveryStart: window.TimeSlotConfig.thresholdDeliveryStart,
      thresholdDeliveryEnd: window.TimeSlotConfig.thresholdDeliveryEnd,
    };

    if (checkAvailability.isLimited) {
      prepareTimes.availableFrom = checkAvailability.availableFrom;
      prepareTimes.availableTill = checkAvailability.availableTill;
    }

    if (checkAvailability.method === 2) {
      prepareTimes.minStartTime = checkAvailability.minDeliveryStart;
    }

    if (checkAvailability.method === 4) {
      prepareTimes.minHoursRequiredOffThreshold = checkAvailability.minHoursRequiredOffThreshold;
      prepareTimes.minStartTime = checkAvailability.minDeliveryThreshold;
      prepareTimes.minStartTimeOff = checkAvailability.minDeliveryOffThreshold;
    }

  } else {
    hideInput(parentSection);
    showMessage(
      parentSection,
      window.timeSlotStrings.variantDataNotDefined
    );
    return;
  }

  const timeIntervals = prepareIntervals(prepareTimes);

  if (timeIntervals.length < 1) {
    hideInput(parentSection);
    showMessage(
      parentSection,
      window.timeSlotStrings.nullComputedIntervals
    );
    return;
  } else {
    showInput(parentSection);
    hideMessage(parentSection);
  }

  if (
    productForm.querySelector('.date-time-picker-inputs') == null
  ) {
    var newDiv = document.createElement("div");
    newDiv.className = "date-time-picker-inputs";
    if (type == "product") {
      productForm.prepend(newDiv);
    } else {
      let productFormWrapper = productForm.querySelector(".m-product-form--wrapper");
      let atcButton = productForm.querySelector(".m-add-to-cart");
      productFormWrapper.insertBefore(newDiv, atcButton);
    }
    var newDivTime = document.createElement("div");
    newDivTime.className = "time-input-block";
    newDiv.appendChild(newDivTime);
    var newInput1 = document.createElement("select");
    newInput1.className = "time-slot";
    newInput1.required = "required";
    newInput1.name = "properties[Delivery Slot]";
    newInput1.add(new Option("Select Slot", ""));
    newDivTime.prepend(newInput1);
    var newLabel = document.createElement("label");
    newLabel.innerHTML = "Preferred Slot";
    newLabel.className = "form__label";
    newDivTime.prepend(newLabel);
    var parentNodeInputs = productForm.querySelector('.date-time-picker-inputs');
    var newDivDate = document.createElement("div");
    newDivDate.className = "date-input-block";
    parentNodeInputs.prepend(newDivDate);
    var newInput = document.createElement("input");
    newInput.type = "date";
    newInput.required = "required";
    newInput.name = "date-input-element";
    newInput.className = "date-slot";
    newInput.required = "required";
    newInput.max = timeIntervals[timeIntervals.length - 1].date;
    newInput.min = timeIntervals[0].date;
    newDivDate.prepend(newInput);
    var newLabel1 = document.createElement("label");
    newLabel1.innerHTML = "Preferred Date";
    newLabel1.className = "form__label";
    newDivDate.prepend(newLabel1);
    var newInput2 = document.createElement("input");
    newInput2.type = "hidden";
    newInput2.name = "properties[Delivery Date]";
    newInput2.value = "";
    newDivDate.prepend(newInput2);
  } else {
    productForm.querySelector('select[name="properties[Delivery Slot]"]').innerHTML = "";
    productForm.querySelector('select[name="properties[Delivery Slot]"]').add(new Option("Select Slot", ""));
    productForm.querySelector('select[name="properties[Delivery Slot]"]').value = "";
    productForm.querySelector('input[name="date-input-element"]').max = timeIntervals[timeIntervals.length - 1].date;
    productForm.querySelector('input[name="date-input-element"]').min = timeIntervals[0].date;
    productForm.querySelector('input[name="date-input-element"]').value = "";
  }
  
  productForm.querySelector('button[type="submit"]').disabled = "disabled";

  productForm.querySelector('input[name="date-input-element"]').addEventListener("change", function(newEvent) {
    
    hideMessage(parentSection);

    var getSelect = productForm.querySelector('.time-input-block');
    getSelect.style.display = "flex";

    let getTimeSlots = timeIntervals.filter(el => { return  el.date === newEvent.target.value });

    if (getTimeSlots.length) {
      if (getTimeSlots[0].timeSlots.length) {
        var getSelect = productForm.querySelector('select[name="properties[Delivery Slot]"]');
        getSelect.innerHTML = "";
        getSelect.add(new Option("Select Slot", ""));
        getTimeSlots[0].timeSlots.forEach(el => {
          var newOption = new Option(el, el);
          getSelect.add(newOption, undefined);
        });
        getSelect.addEventListener("change", function(event) {
          if(event.target.value != '') {
            if (enableButton(parentSection)) {
              productForm.querySelector('button[type="submit"]').disabled = "";
            }
          } else {
            productForm.querySelector('button[type="submit"]').disabled = "disabled";
          }
        });
        getPreferedDate = productForm.querySelector('input[name="properties[Delivery Date]"]');
        getPreferedDate.value = DateTime.fromFormat(newEvent.target.value, "yyyy-MM-dd").toFormat("EEE, dd LLL yyyy");
      }
    } else {
      var getSelect = productForm.querySelector('.time-input-block');
      getSelect.style.display = "none";
      productForm.querySelector('button[type="submit"]').disabled = "disabled";
      showMessage(
        parentSection,
        window.timeSlotStrings.nullComputedIntervals
      );
    }
  });
}

function initTimeOptions() {
  var timingBlocks = document.querySelectorAll(".timing-block");
  timingBlocks.forEach(block => {
    initSingleTimeSlot(block, "product");
  });
}

function initTimeOptionsModal() {
  let getModal = document.querySelector(".m-product-quickview");
  var timingBlocks = getModal.querySelectorAll(".timing-block");
  timingBlocks.forEach(block => {
    initSingleTimeSlot(block, "modal");
  });
  
  var selectTrigger = getModal.querySelectorAll('select[name="select-city"]');
  if (selectTrigger.length) {
    selectTrigger.forEach(el => {
      el.addEventListener("change", event => {
        eraseCookie("delivery-city");
        createCookie("delivery-city", event.target.value, 7);
        initTimeOptionsModal();
      });
    });
  }
}

function updateText(currentCity) {
  var currentCityWrapper = document.querySelectorAll(
    'select[name="select-city"]'
  );
  if (currentCityWrapper.length) {
    currentCityWrapper.forEach(el => {
      el.value = currentCity;
    });
  }
}

function clearCart() {
  fetch(window.Shopify.routes.root + "cart/clear.js").then(response => {return response.json();}).then(data => {eraseCookie("deliverySlot");});
}

function clearCartRedirect() {
  fetch(window.Shopify.routes.root + "cart/clear.js").then(response => {return response.json();}).then(data => {eraseCookie("deliverySlot"); window.location = window.MinimogSettings.routes.cart;});
}

function checkLineItems(cartJSON) {
  if (cartJSON.items.length) {
    const cartUpdatedAt = readCookie('cart-time');
    if (!checkNullUndefined(cartUpdatedAt)) {
      if (currentTime.diff(cartUpdatedAt, 'minutes', true) > 30) {
        clearCart();
      }
    } else {
      clearCart();
    }

    cartJSON.items.forEach((item, index) => {
      if (item.properties != null) {
        if (item.properties["Delivery Date"] !== undefined && item.properties["Delivery Slot"] !== undefined) {
          eraseCookie("deliverySlot");
          createShortCookie("deliverySlot", item.properties["Delivery Date"] + " " + item.properties["Delivery Slot"], 30);
          return true;
        }
      }
    });
  } else {
    eraseCookie("deliverySlot");
  }
  initTimeOptions();
}

function checkCartItems() {
  let isCartEmpty = readCookie("checkCart");
  if (checkNullUndefined(isCartEmpty)) {
    fetch(window.Shopify.routes.root + "cart.js")
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data.items.length) {
        createShortCookie("checkCart", false, 30);
        checkLineItems(data);
      } else {
        createShortCookie("checkCart", false, 30);
      }
    })
    .catch(error => {
      console.error("Error:", error);
    });
  }
}

document.addEventListener("quick-view:loaded", event => {
  setTimeout(function() {
    let getModal = document.querySelector(".m-product-quickview");
    populateCities(getModal.querySelector('select[name="select-city"]'));
    initTimeOptionsModal();
    const timeslotsBlockQV = document.querySelector(".timeslot-bundles[data-section='product-quickview']");
    if (timeslotsBlockQV !== null) {
      const parentSectionQV = timeslotsBlockQV.closest('.m-product-info--wrapper');
      const productFormQV = parentSectionQV.querySelector('form[data-type="add-to-cart-form"]');
      if (productFormQV.querySelector('input[name="properties[Flavours]"') === null) {
        var newDiv = document.createElement("input");
        newDiv.name = "properties[Flavours]";
        newDiv.type = "hidden";
        productFormQV.prepend(newDiv);
      }
      
      function updateButtons() {
        let currentValue = 0;
        let flavoursArray = [];
        timeslotsBlockQV.querySelectorAll('input[name="quantity"]').forEach((input) => {
          currentValue = currentValue + parseInt(input.value);
          if (input.value != 0) {
            let nearestCheckbox = input.closest('.single-option-bundle');
            flavoursArray.push(nearestCheckbox.querySelector('input[type="checkbox"]').value + ' * ' + input.value);
          }
        });
        timeslotsBlockQV.dataset.currentQuantity = currentValue;
        
        if (timeslotsBlockQV.dataset.currentQuantity === timeslotsBlockQV.dataset.maxAllowed) {
          timeslotsBlockQV.querySelectorAll('button.m-quantity__button[name="plus"]').forEach((el) => {
            el.disabled = "disabled";
          });
          let deliveryDate = productFormQV.querySelector('input[name="properties[Delivery Date]"]');
          let deliveryTime = productFormQV.querySelector('select[name="properties[Delivery Slot]"]');
          if (deliveryDate != null &&  deliveryDate.value != '' && deliveryTime != null && deliveryTime.value != '') {
            productFormQV.querySelector('button[type="submit"]').disabled = "";
          }
        } else {
          productFormQV.querySelector('button[type="submit"]').disabled = "disabled";
          timeslotsBlockQV.querySelectorAll("input[type=checkbox]").forEach((element) => {
            if (element.checked) {
              let parentNode = element.closest('.single-option-bundle');
              parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
                el.disabled = "";
              });
            } else {
              let parentNode = element.closest('.single-option-bundle');
              parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
                el.disabled = "disabled";
              });
            }
          });
        }
        productFormQV.querySelector('input[name="properties[Flavours]"').value = flavoursArray.toString();
      }
      
      timeslotsBlockQV.querySelectorAll("input[type=checkbox]").forEach((element) => {
        element.onchange = (event) => {
          let selectedCheckBox = event.target;
          let parentNode = selectedCheckBox.closest('.single-option-bundle');
          if (event.target.checked) {
            if (timeslotsBlockQV.dataset.currentQuantity === timeslotsBlockQV.dataset.maxAllowed) {
              event.target.checked = false;
            } else {
              parentNode.querySelector('input[name="quantity"]').value = 1;
              parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
                el.disabled = "";
              });
            }
          } else {
            parentNode.querySelector('input[name="quantity"]').value = 0;
            parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
              el.disabled = "disabled";
            });
          }
          updateButtons();
        };
      });
      
      timeslotsBlockQV.querySelectorAll('button.m-quantity__button').forEach((el) => {
        el.onclick = (evt) => {
          timeslotsBlockQV.querySelectorAll('button.m-quantity__button[name="plus"]').forEach((el) => {
            el.disabled = "";
          });
          setTimeout(() => {
            updateButtons()
          }, 500);
        }
      });
    }
  }, 500);
});

document.addEventListener('variant:changed', function(event) {
  let allForms = event.srcElement.forms;
  let activeForm = allForms[0];
  for (let singleForm of allForms) {
    let selectedInput = singleForm.querySelector('input[name="id"]');
    let formId = singleForm.getAttribute('id');
    if (selectedInput != null && formId !== 'product-form-installment') {
      if (selectedInput.value === event.detail.variant.id.toString()) {
        activeForm = singleForm;
      }
    }
  }
  
  let getModal = activeForm.closest('.m-product-quickview--info');
  let sectionType = getModal !== null ? "modal" : "product";
  let getSection = getModal !== null ? getModal : activeForm.closest('.m-main-product--info');

  if (
    getSection.querySelector(
      'input[name="date-input-element"]'
    ) !== null
  ) {
    getSection.querySelector(
      'input[name="date-input-element"]'
    ).value =
      "";
    getSection.querySelector(
      'select[name="properties[Delivery Slot]"]'
    ).value =
      "";
  }
  getSection.querySelector(".timing-block").dataset.variantId = event.detail.variant.id;
  initSingleTimeSlot(
    getSection.querySelector(".timing-block"),
    sectionType
  );
});

document.addEventListener('product-ajax:added', function(event) {
  eraseCookie('cart-time');
  createShortCookie('cart-time', Date.now(), 30);
  setTimeout(() => {
    fetch(window.Shopify.routes.root + "cart.js")
    .then(response => {
      return response.json();
    })
    .then(data => {
      checkLineItems(data);
    })
    .catch(error => {
      console.error("Error:", error);
    });
  }, 500);
});

document.addEventListener('cart:updated', function(event) {
  checkLineItems(event.detail.cart);
});

setInterval(()=> {
  checkCartItems();
}, 10000);

window.addEventListener("load", event => {
  checkCartItems();
  availabeSlots();
  populateCities(document.querySelector('select[name="select-city"]'));
  let currentCity = readCookie("delivery-city");
  if (checkNullUndefined(currentCity)) {
    createCookie("delivery-city", window.TimeSlotConfig.defaultCity, 7);
    updateText(window.TimeSlotConfig.defaultCity);
  } else {
    updateText(currentCity);
  }
  var selectTrigger = document.querySelectorAll('select[name="select-city"]');
  if (selectTrigger.length) {
    selectTrigger.forEach(el => {
      el.addEventListener("change", event => {
        eraseCookie("delivery-city");
        createCookie("delivery-city", event.target.value, 7);
        initTimeOptions();
      });
    });
  }
  initTimeOptions();
});

// window.addEventListener("load", async (event) => {
//   checkCartItems();
  
//   await availableSlots(); // Wait for slots to be fetched and stored first
  
//   populateCities(document.querySelector('select[name="select-city"]'));
  
//   let currentCity = readCookie("delivery-city");
//   if (checkNullUndefined(currentCity)) {
//     createCookie("delivery-city", window.TimeSlotConfig.defaultCity, 7);
//     updateText(window.TimeSlotConfig.defaultCity);
//   } else {
//     updateText(currentCity);
//   }
  
//   var selectTrigger = document.querySelectorAll('select[name="select-city"]');
//   if (selectTrigger.length) {
//     selectTrigger.forEach(el => {
//       el.addEventListener("change", event => {
//         eraseCookie("delivery-city");
//         createCookie("delivery-city", event.target.value, 7);
//         initTimeOptions();
//       });
//     });
//   }
  
//   initTimeOptions(); // Now runs after slots are guaranteed to be in localStorage
// });

if (typeof timeslotsBlock != 'undefined' && timeslotsBlock !== null) {
  const parentSection = timeslotsBlock.closest('.m-main-product--wrapper');
  const productForm = parentSection.querySelector('form[data-type="add-to-cart-form"]');
  if (productForm.querySelector('input[name="properties[Flavours]"') === null) {
    var newDiv = document.createElement("input");
    newDiv.name = "properties[Flavours]";
    newDiv.type = "hidden";
    productForm.prepend(newDiv);
  }
  
  function updateButtons() {
    let currentValue = 0;
    let flavoursArray = [];
    timeslotsBlock.querySelectorAll('input[name="quantity"]').forEach((input) => {
      currentValue = currentValue + parseInt(input.value);
      if (input.value != 0) {
        let nearestCheckbox = input.closest('.single-option-bundle');
        flavoursArray.push(nearestCheckbox.querySelector('input[type="checkbox"]').value + ' * ' + input.value);
      }
    });
    timeslotsBlock.dataset.currentQuantity = currentValue;
    
    if (timeslotsBlock.dataset.currentQuantity === timeslotsBlock.dataset.maxAllowed) {
      timeslotsBlock.querySelectorAll('button.m-quantity__button[name="plus"]').forEach((el) => {
        el.disabled = "disabled";
      });
      let deliveryDate = productForm.querySelector('input[name="properties[Delivery Date]"]');
      let deliveryTime = productForm.querySelector('select[name="properties[Delivery Slot]"]');
      if (deliveryDate != null &&  deliveryDate.value != '' && deliveryTime != null && deliveryTime.value != '') {
        productForm.querySelector('button[type="submit"]').disabled = "";
      }
    } else {
      productForm.querySelector('button[type="submit"]').disabled = "disabled";
      timeslotsBlock.querySelectorAll("input[type=checkbox]").forEach((element) => {
        if (element.checked) {
          let parentNode = element.closest('.single-option-bundle');
          parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
            el.disabled = "";
          });
        } else {
          let parentNode = element.closest('.single-option-bundle');
          parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
            el.disabled = "disabled";
          });
        }
      });
    }
    productForm.querySelector('input[name="properties[Flavours]"').value = flavoursArray.toString();
  }
  
  timeslotsBlock.querySelectorAll("input[type=checkbox]").forEach((element) => {
    element.onchange = (event) => {
      let selectedCheckBox = event.target;
      let parentNode = selectedCheckBox.closest('.single-option-bundle');
      if (event.target.checked) {
        if (timeslotsBlock.dataset.currentQuantity === timeslotsBlock.dataset.maxAllowed) {
          event.target.checked = false;
        } else {
          parentNode.querySelector('input[name="quantity"]').value = 1;
          parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
            el.disabled = "";
          });
        }
      } else {
        parentNode.querySelector('input[name="quantity"]').value = 0;
        parentNode.querySelectorAll('button.m-quantity__button').forEach((el) => {
          el.disabled = "disabled";
        });
      }
      updateButtons();
    };
  });
  
  timeslotsBlock.querySelectorAll('button.m-quantity__button').forEach((el) => {
    el.onclick = (evt) => {
      timeslotsBlock.querySelectorAll('button.m-quantity__button[name="plus"]').forEach((el) => {
        el.disabled = "";
      });
      setTimeout(() => {
        updateButtons()
      }, 500);        
    }
  });
}